<template>
  <div id="app">
    <Header/>
    <Hero/>
    <Experience/>
    <Technology/>
    <Projects/>
    <Footer/>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import Header from './components/Header.vue'
import Hero from './components/Hero.vue'
import Experience from './components/Experience.vue'
import Technology from './components/Technology.vue'
import Projects from './components/Projects.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Hero,
    Experience,
    Technology,
    Projects,
    Footer,
  }
}
</script>